import api from './axios';
import {
  CashCurrent,
  CashSession,
  CashHistoryFilters,
  CashExpensesResponse,
  CashSummary,
  CashMovement,
  ExchangeRate,
  OpenCashInput,
  CloseCashInput,
} from '../types/cash';

export const cashApi = {
  current: () => api.get<CashCurrent>('/cash/current'),

  // Tipo de cambio SUNAT del dia (cache por fecha).
  getExchangeRate: () => api.get<ExchangeRate>('/cash/exchange-rate'),
  refreshExchangeRate: () => api.post<ExchangeRate>('/cash/exchange-rate/refresh'),
  setExchangeRate: (date: string, buy: number, sell: number) =>
    api.post('/cash/exchange-rate', { date, buy, sell }),

  // Apertura con PEN + USD + TC opcional. Si el TC viene en 0, el backend lo trae solo.
  open: (input: OpenCashInput) => api.post<CashSession>('/cash/open', input),

  // Cierre con conteo PEN + USD + notas.
  close: (input: CloseCashInput) => api.post<CashSession>('/cash/close', input),

  movement: (type: 'ingreso' | 'egreso', amount: number, concept: string) =>
    api.post('/cash/movements', { type, amount, concept }),

  // Gastos diarios: reutilizan cash_movements con type='egreso'.
  getExpenses: () => api.get<CashExpensesResponse>('/cash/expenses'),
  addExpense: (amount: number, concept: string) =>
    api.post<CashMovement>('/cash/expenses', { amount, concept }),

  history: (filters?: CashHistoryFilters) =>
    api.get<CashSession[]>('/cash/history', { params: filters }),
  getById: (id: number) => api.get<CashSummary>(`/cash/${id}`),
};
